const SearchFormView = ({ query, setQuery, onSearch, loading }) => {
  return (
    <div className="search-form">
      <input
        type="text"
        placeholder="Painting, artist, year..."
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        onKeyDown={(keyEvent) => {
          if (keyEvent.key === "Enter") {
            keyEvent.preventDefault(); 
            onSearch(); 
          }
        }}
        className="search-input"
      />
      <button
        onClick={onSearch}
        disabled={loading}
        className="search-button"
      >
        {loading ? "Loading..." : "Search"}
      </button>
    </div>
  );
};

export default SearchFormView;